<template>
    <v-container>
        <ModuleClosedAlert module="site.plan_adherence" />
        <div class="limiter-content pa-2 pa-lg-0">
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-10 title-page" tabindex="0">Adesão ao Plano</div>
                </v-col>
            </v-row>

            <br />

            <div class="mt-4" v-if="dataset.loading || !user || dataset.loadingCreditors">
                <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </div>

            <div v-html="dataset.description" tabindex="0"></div>

            <br>

            <v-container v-if="user">
                <v-row class="mb-4" align="center">
                    <v-col cols="12" sm="6" class="d-flex align-center">
                        <v-select v-model="selectedCreditor" outlined dense :items="creditors" label="Selecione credor"
                            no-data-text="Nenhum credor disponível" :disabled="dataset.loadingCreditors" return-object
                            item-text="name" item-value="id" @change="onCreditorChangeFirtLoad" class="flex-grow-1">
                            <template v-slot:item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ getFormattedRegistration(item.registration)
                                        }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-select>
                    </v-col>
                </v-row>

                <v-container v-if="!loadingInitial">

                    <v-row v-if="!dataset.confirmedRead" no-gutters class="mb-4">
                        <v-col>
                            <div class="plan-pdf-viewer mb-5">
                                <div class="plan-pdf-toolbar">
                                    <div>
                                        <div class="text-subtitle-2 font-weight-bold primary--text">
                                            Plano de Recuperação Judicial
                                        </div>
                                        <div class="text-caption grey--text text--darken-1">
                                            Leia o documento antes de confirmar a adesão.
                                        </div>
                                    </div>
                                    <div class="plan-pdf-actions">
                                        <v-btn small outlined color="primary" class="mr-2" @click="openPlanPdf">
                                            <v-icon left small>mdi-open-in-new</v-icon>
                                            Abrir plano
                                        </v-btn>
                                        <v-btn small text color="primary" @click="savePdfFromIframe">
                                            <v-icon left small>mdi-download-outline</v-icon>
                                            Baixar termo
                                        </v-btn>
                                    </div>
                                </div>

                                <iframe class="plan-pdf-frame" :src="planViewerUrl" title="Plano de Recuperação Judicial"
                                    frameborder="0" @error="dataset.pdfLoadError = true"></iframe>
                            </div>

                            <span v-if="dataset.pdfLoadError" class="error-text">Erro ao carregar documento de
                                adesão.</span>


                            <br>
                            <br>
                            <v-checkbox :rules="[$rules.required]" v-model="dataset.confirmReadPlan" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Confirmo que li o Plano de Recuperação Judicial por inteiro e estou
                                        ciente sobre as cláusulas apresentadas pelo Grupo 123 Milhas e as opções de
                                        pagamento ofertadas para os credores da Recuperação Judicial;
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptResponsibility" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Declaro que sou o titular das informações preenchidas nesta plataforma ou possuo
                                        poderes atribuídos para utilização dos dados, sendo responsável pelo
                                        preenchimento
                                        adequado e verdadeiro dos dados, sob as penas da Lei;
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptTerms" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que a adesão ao Plano de Recuperação Judicial através desta
                                        plataforma implica a consideração por parte da Administração Judicial e do Juízo
                                        da
                                        Recuperação
                                        Judicial de que sou favorável à aprovação do Plano de Recuperação Judicial das
                                        Empresas 123 VIAGENS E TURISMO LTDA. (CNPJ: 26.669.170/0001-57), ART VIAGENS E
                                        TURISMO LTDA.
                                        (CNPJ: 11.442.110/0001-20), NOVUM INVESTIMENTOS PARTICIPAÇÕES S.A. (CNPJ:
                                        26.941.940/0001-79), LH - LANCE HOTEIS LTDA. (CNPJ: 24.813.491/0001-58) e MM
                                        TURISMO
                                        & VIAGENS S.A.
                                        (CNPJ: 16.988.607/0001-61);
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptRemoveAdhesionAgc" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que, conforme disposto no Termo de Adesão, a assinatura deste
                                        Termo de Adesão pelo Credor importa aceite irrevogável e irretratável a todos os
                                        termos do Plano de Recuperação Judicial, desde que a versão do plano de
                                        recuperação judicial submetida à aprovação dos credores e à homologação do juízo
                                        recuperacional reflita exatamente as condições de pagamento aplicáveis ao Credor
                                        previstas no Plano apresentado no dia 26/12/2024, ao qual o Credor adere na
                                        presente data, não sendo possível a alteração de sua manifestação em
                                        Assembleia-Geral de Credores.
                                    </div>
                                    <!-- <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que posso retirar a adesão durante a Assembleia Geral de
                                        Credores,
                                        se desejar,
                                        desde que esteja regularmente credenciado e tenha comparecido durante a
                                        instalação
                                        do Ato.
                                    </div> -->
                                </template>
                            </v-checkbox>

                            <v-alert v-if="!allCheckmarksChecked" type="warning" outlined dense border="left"
                                class="mb-4">
                                Para prosseguir, leia atentamente e, se estiver de acordo, marque todas as opções acima.
                            </v-alert>

                            <v-btn color="primary" :disabled="!allCheckmarksChecked || loadingContinue"
                                @click="onCreditorChange">
                                <v-progress-circular v-if="loadingContinue" indeterminate size="20" color="white"
                                    class="mr-2">
                                </v-progress-circular>
                                Prosseguir
                            </v-btn>
                        </v-col>
                    </v-row>

                    <div v-if="!selectedCreditor && dataset.confirmedRead && creditors.length > 0">
                        <h4>Selecione um credor para visualizar as informações e continuar com a adesão ao plano.</h4>
                    </div>
                    <div v-if="creditors.length === 0 && !dataset.loadingCreditors && dataset.confirmedRead">
                        <h4>Você não possui credores associados para prosseguir com a Adesão ao Plano.</h4>
                    </div>

                    <template v-if="selectedCreditor && dataset.confirmedRead">
                        <v-alert v-if="!hasCreditor" type="info" outlined>
                            Este credor não consta na lista de credores, portanto, não será possível prosseguir com a
                            adesão ao plano.
                        </v-alert>

                        <v-alert v-else-if="!dataset.allowedSignature && hasCreditor && dataset.confirmedRead"
                            type="info" outlined>
                            Há um pedido de revisão de crédito em aberto, portanto, não será possível prosseguir com a
                            adesão ao plano.
                        </v-alert>
                        
                        <v-alert v-else-if="hasCreditor && isUserDataIncomplete && dataset.confirmedRead" type="warning"
                            border="left" color="warning" elevation="2" dense class="text--primary">
                            O cadastro do credor selecionado está incompleto! Para prosseguir com a adesão ao plano,
                            é necessário que o credor atualize seus dados cadastrais na seção <strong>Minha
                                Conta</strong>,
                            acessível após login na área restrita deste site.
                        </v-alert>

                        <template v-else-if="hasMoreClass && dataset.confirmedRead">
                            <v-alert type="info" border="left" color="info" elevation="2" dense>
                                Este credor está relacionado em mais de uma classe. Selecione a classe que deseja
                                utilizar para realizar a adesão ao plano.
                            </v-alert>

                            <v-select v-model="selectedClass" :items="hasMoreClass" item-text="name" item-value="id"
                                label="Selecione a Classe" dense outlined class="mt-4" @change="onClassChanged">
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Classe {{ data.item.name }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-select>

                            <v-btn color="primary" class="mt-3" :disabled="!showButtonConfirm"
                                @click="confirmSelectedClass">
                                Confirmar Classe
                            </v-btn>
                            <br>
                        </template>
                        <br>
                        <template v-if="hasCreditor">
                            <div v-if="dataset.loadingData" class="text-center">
                                <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
                            </div>
                            <div v-else-if="showProcessedContent && processedContent">
                            <!-- <div v-else-if="showProcessedContent && processedContent && hasCreditor"> -->
                                <v-divider></v-divider>
                                <br>
                                <v-card class="pa-4" color="grey lighten-5" flat>
                                    <div v-html="processedContent" tabindex="0"></div>
                                </v-card>

                                <v-row class="mt-6">
                                    <v-col cols="12">
                                        <v-card outlined class="pa-3">
                                            <v-row align="center">
                                                <v-col :cols="dataset.adherence && dataset.adherence.status === 1 ? '7' : '12'">
                                                    <v-card-title class="font-weight pb-2 pl-3">
                                                        Status da adesão:
                                                    </v-card-title>
                                                    <v-card-text class="pt-0 pl-3">
                                                        <v-alert
                                                            v-if="dataset.adherence && dataset.adherence.status !== null && dataset.adherence.status !== undefined"
                                                            :color="getColorByStatus(dataset.adherence.status)"
                                                            text-color="white" rounded="pill" dense dark
                                                            class="mt-4 d-inline-block px-4 py-2" tabindex="0">
                                                            {{ getTextByStatus(dataset.adherence.status) }}
                                                        </v-alert>
                                                        
                                                        <v-alert v-else color="grey lighten-1" text-color="white" rounded="pill"
                                                            dense dark class="mt-4"
                                                            style="max-width: 300px; height: 35px; display: inline-flex; align-items: center; justify-content: center;"
                                                            tabindex="0">
                                                            Nenhuma informação disponível
                                                        </v-alert>
                                                        
                                                        <p class="mt-2">{{ dataset.adherence.validation_result || 'Sem resultado de validação' }}</p>
                                                    </v-card-text>
                                                </v-col> <template v-if="dataset.adherence && dataset.adherence.status === 1">
                                                    <v-divider vertical class="my-4"></v-divider>

                                                    <v-col class="px-6">
                                                        <div class="text-subtitle-1 font-weight-bold mb-2">
                                                            Deseja manifestar interesse na troca da opção?
                                                        </div>
                                                        <p class="body-2 grey--text text--darken-1">
                                                            Clique no botão abaixo para manifestar interesse em trocar sua opção escolhida na adesão
                                                        </p>
                                                        
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn 
                                                                    color="primary" 
                                                                    outlined 
                                                                    v-bind="attrs" 
                                                                    v-on="on"
                                                                    @click="handleInterestChange"
                                                                >
                                                                    <v-icon left>mdi-swap-horizontal</v-icon>
                                                                    Manifestar Interesse
                                                                </v-btn>
                                                            </template>
                                                            <span>Clique para manifestar interesse em trocar sua opção</span>
                                                        </v-tooltip>
                                                    </v-col> </template>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-6">
                                    <v-col cols="12" sm="6">
                                        <div class="d-flex align-center">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-bind="attrs" v-on="on" color="primary"
                                                        :loading="dataset.downloading"
                                                        :disabled="dataset.loading || dataset.downloading || (dataset.adherence && dataset.adherence.status === 1)"
                                                        @click="showSignatureInfo = true">
                                                        {{ dataset.adherence.status == null ? 'Gerar PDF' : 'Gerar novo PDF' }}
                                                    </v-btn>
                                                </template>
                                                <span>Gerar documento PDF para ser assinado</span>
                                            </v-tooltip>

                                            <v-tooltip v-if="dataset.adherence && dataset.adherence.status !== 1" bottom
                                                max-width="400">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon small class="ml-2" color="grey darken-1" v-bind="attrs"
                                                        v-on="on" @click="showHelpSignature = true">
                                                        <v-icon>mdi-help-circle-outline</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Ajuda para assinar digitalmente o documento</span>
                                            </v-tooltip>

                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-file-input v-model="signedPdf" label="Upload PDF Assinado"
                                            accept="application/pdf" :loading="dataset.uploading" :truncate-length="50"
                                            :disabled="dataset.loading || dataset.uploading || !dataset.adherence || dataset.adherence.status === null || dataset.adherence.status === undefined || dataset.adherence.status === 1"
                                            prepend-icon="mdi-upload" @change="uploadPdf">
                                        </v-file-input>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                    </template>

                </v-container>

                <div class="mt-10" v-if="!user">
                    <h4>Por favor, realize o seu login para ter acesso à Adesão ao Plano.</h4>
                </div>

            </v-container>

        </div>

        <!-- Modal com lista de opções -->
        <v-dialog v-model="showClassOptionModal" max-width="900px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold primary--text">
                    {{ getClassTitle(selectedClassType) }}
                </v-card-title>
                <v-card-text>
                    <p class="mb-6">
                        Selecione uma das opções disponíveis. Ao selecionar, o descritivo da opção será exibido.
                    </p>
                    <v-select class="mb-4" label="Selecione uma opção" :items="getOptionsByClass(selectedClassType)"
                        item-text="text" item-value="value" v-model="optionSelect" outlined dense>
                    </v-select>
                    <v-card v-if="optionSelected" class="pa-4 grey lighten-4" outlined elevation="1">
                        <v-card-title class="subtitle-1 font-weight-bold">
                            Detalhes da Opção Selecionada
                        </v-card-title>
                        <v-card-text>
                            <div
                                    style="max-height: 300px; overflow-y: auto;"
                                    v-html="getOptionLongText"
                                >    
                            </div>

                            <!-- <v-row dense>
                                <template v-for="(value, key) in optionSelected">
                                    <v-col v-if="key !== 'col8'" :key="key" cols="12" sm="12">
                                        <strong>{{ mapKeyToLabel(key) }}:</strong> {{ value }}
                                    </v-col>
                                </template> -->
                                <!-- <v-col cols="12" sm="12" v-for="(value, key, i) in optionSelected" :key="i">
                                    <strong>{{ mapKeyToLabel(key) }}:</strong> {{ value }}
                                </v-col> 
                            </v-row>-->
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" :disabled="!optionSelect" @click="confirmOption">
                        Confirmar Seleção
                    </v-btn>
                    <v-btn text @click="showClassOptionModal = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Modal de manifestação de interesse em troca de opção -->
        <v-dialog v-model="interestDialog.show" max-width="600px" persistent>
            <v-card v-if="interestDialog.show">
                <v-card-title class="headline primary white--text">
                 Manifestar Troca Opção
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="interestDialog.show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="mt-4">

                    <div class="pa-4 mb-6 rounded-lg" style="background-color: #f1f5f9; border-left: 4px solid #64748b;">
                        <div class="grey--text text--darken-2 caption font-weight-bold text-uppercase mb-1">
                            Opção Atual: <strong>{{ currentOptionText() }}</strong>
                        </div>  
                       
                    </div>

                    <div class="mt-4">
                        <span class="grey--text text--darken-2 caption font-weight-bold text-uppercase mb-3">
                            Selecione a nova Opção
                        </span>
                        <v-select v-model="interestDialog.selectedOption" :items="interestDialog.availableOptions"
                            item-text="text" item-value="value" label="Opção de pagamento" dense outlined
                            class="mt-3" no-data-text="Nenhuma opção encontrada para esta classe">
                            <template v-slot:item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                    </div>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="interestDialog.show = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" :disabled="!interestDialog.selectedClass || !interestDialog.selectedOption"
                        :loading="interestDialog.loading" @click="submitInterestChange">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

         <!-- Infos procedimento assinatura antes de gerar o PDF -->
        <v-dialog v-model="showSignatureInfo" max-width="650" persistent>
            <v-card>

                <v-card-title class="headline d-flex align-center pb-2 blue darken-4 white--text">
                    <v-icon color="white" large class="mr-3">mdi-draw-pen</v-icon>
                    Assinatura Termo de Adesão
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showSignatureInfo = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-sheet color="orange darken-2" class="px-4 py-2 d-flex align-center justify-center">
                    <v-icon color="white" class="mr-2">mdi-alert</v-icon>
                    <span class="white--text font-weight-bold text-uppercase body-1">
                        Atenção
                    </span>
                </v-sheet>

                <v-card-text class="pt-4">
                    <v-alert dense outlined class="mb-5 font-weight-medium text-justify">
                        Conforme determinação de <strong>ID 10581712116</strong>, proferida em <strong>14/11/2025</strong>,
                        os Termos de Adesão deverão ser assinados através da plataforma do <strong>GOV.BR</strong>.
                    </v-alert>

                    <div class="text-subtitle-2 mb-2">
                        Antes de prosseguir, siga atentamente as orientações abaixo:
                    </div>

                    <v-list dense class="transparent pa-0">
                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-file-document-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2">Utilize <strong>somente o último documento gerado</strong> pelo
                                    sistema para
                                    efetuar a assinatura. Documentos antigos serão automaticamente rejeitados;</span>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-pencil-off-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2"><strong>Não altere ou modifique</strong> o documento. Qualquer
                                    edição poderá corromper a estrutura e validação;</span>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-content-save-off-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2"><strong>Não renomeie ou use a função "Salvar como"</strong>.
                                    Gere o documento e utilize o arquivo original diretamente no portal gov.br;</span>

                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small class="mr-3 mt-1 align-self-start">mdi-printer-off</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2">Não "imprima como PDF" (Print to PDF), antes e depois da assinatua, 
                                    pois isso irá comprometer a validade do documento.</span>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="showSignatureInfo = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" depressed @click="confirmAndProceed">
                        Entendi e Prosseguir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <!-- Dialog de ajuda para assinatura digital -->
        <v-dialog v-model="showHelpSignature" max-width="700" persistent>
            <v-card>

                <v-card-title class="headline d-flex align-center pb-2 primary white--text">
                    <v-icon color="white" large class="mr-3">mdi-draw-pen</v-icon>
                    Procedimento para assinar o documento
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showHelpSignature = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

              <v-divider></v-divider>

                <v-card-text class="pt-4 pb-0">

                    <v-alert dense outlined icon="mdi-shield-alert-outline" class="mb-4 font-weight-medium text-justify"
                        color="orange darken-2">
                        <span class="orange--text text--darken-2">
                            A assinatura digital deve ser realizada <strong>obrigatoriamente</strong>
                            pelo portal <strong>gov.br</strong>, utilizando conta de nível
                            <strong>Prata</strong> ou <strong>Ouro</strong>. Mesmo que você possua outros
                            métodos ou certificados de autenticação, o documento <strong>não será validado</strong>
                            se assinado por outros meios.
                        </span>
                    </v-alert>

                    <div class="text-subtitle-2 font-weight-bold mb-3 grey--text text--darken-2">
                        Siga o passo a passo abaixo:
                    </div>
                    <v-timeline dense clipped class="mt-0 pt-0 signature-timeline">

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                <strong>Gere o documento</strong> clicando em
                                <strong><em>"GERAR PDF"</em></strong>. O arquivo PDF será gerado e salvo na sua
                                pasta de <strong>Downloads</strong>.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Acesse o portal
                                <a href="https://assinador.iti.br" target="_blank" rel="noopener">
                                    assinador.iti.br
                                    <v-icon x-small color="primary">mdi-open-in-new</v-icon>
                                </a>
                                e faça login com a conta <strong>gov.br</strong> do <strong>procurador</strong> ou
                                do <strong>credor</strong> (nível <strong>Prata</strong> ou <strong>Ouro</strong>).
                                <div class="mt-1 caption grey--text text--darken-1">
                                    <v-icon x-small color="grey darken-1" class="mr-1">mdi-information-outline</v-icon>
                                    O documento pode ser assinado pelo <strong>procurador devidamente credenciado</strong> ou
                                    diretamente pelo <strong>credor titular</strong>.
                                </div>
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Siga os procedimentos dentro do portal gov.br e quando solicitado, selecione o arquivo
                                PDF que foi gerado, <strong>sem renomear ou modificar</strong> o documento.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Conclua o procedimento de assinatura pelo portal gov.br e
                                <strong>baixe o documento assinado</strong>.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Retorne a esta página do site e finalize o processo enviando o arquivo que foi assinado, clicando em
                                <strong>"Upload PDF Assinado"</strong>.
                            </div>
                        </v-timeline-item>
                        
                        <v-timeline-item small color="success" class="mb-2">
                            <div class="body-2">
                                Selecione o arquivo PDF que foi assinado (em geral o nome do arquivo segue o padrão 'termo_adesao_nome_credor_assinado.pdf').
                            </div>
                        </v-timeline-item>

                    </v-timeline>

                    <v-sheet color="red lighten-5" rounded class="pa-3 mb-4 mt-2">
                        <div class="caption font-weight-bold red--text text--darken-2 mb-2 text-uppercase">
                            <v-icon small color="red darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                            Atenção — Ações que invalidam o documento:
                        </div>
                        <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não renomeie o arquivo PDF
                                </div>
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não use "Salvar como" ou "Imprimir como PDF"
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não edite ou modifique o documento PDF
                                </div>
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não use outros certificados ou assinadores
                                </div>
                            </v-col>
                        </v-row>
                    </v-sheet>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">

                    <v-spacer></v-spacer>
                
                    <v-btn color="primary" depressed @click="showHelpSignature = false">
                       Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
  
  <script>
  import 'moment/locale/pt-br';
  import axios from 'axios';
  import creditorTypes from '@/common/data/adherence-creditor-types.data';
  import optionDetailsByClass from '@/common/data/adherence-term-option-by-type.data';
  import enumTermOptionsByClass from '@/common/data/adherence-term-option.data';
  import { downloadPdfResponse, downloadPdfUrl } from '@/common/util/download-file';
  import { eventHub } from '@/main';
  import { cpf, cnpj } from 'cpf-cnpj-validator'
  import actionEventTypes, { EVENT_TYPE } from '@/common/data/action-event-types.data';
  import actionEventSteps, { EVENT_STEP } from '@/common/data/action-event-steps.data';
  
  export default {
    data: () => ({
        process_type: {
            LAWYER_PLAN_ADHERENCE: 2, //Tela de Adesão ao Plano do Procurador
        },
        trackingUploadContext: false,
        interestDialog: {
            show: false,
            loading: false,
            selectedClass: null,
            selectedOption: null,
            availableOptions: [], 
            reason: ''
        },
        user: null,
        loadingInitial: true,
        loadingContinue: false,
        showProcessedContent: false,
        selectedCreditor: null,
        selectedClass: null, 
        selectedClassType: null, 
        showClassOptionModal: false,
        creditors: [],
        representatives: [],
        signedPdf: null,
        optionSelect: null, 
        optionSelected: null, 
        creditorTypes,
        enumTermOptionsByClass,
        optionDetailsByClass,
        showButtonConfirm: false,
        termLocalTimeUpdate: null,
        showSignatureInfo: false,
        showHelpSignature: false,
        dataset: {
            description: '',
            content: '',
            downloading: false,
            uploading: false,
            loading: false,
            loadingData: false,
            loadingCreditors: false,
            userData: {},
            adherence: {},
            confirmedRead: false,
            allowedSignature: false,
            pdfLoadError: false,
            confirmReadPlan: false,
            acceptTerms: false,
            acceptResponsibility: false,
            acceptRemoveAdhesionAgc: false,
        },
    }),
  
    watch: {
        isUserDataIncomplete(incomplete) {
            this.showProcessedContent = !incomplete;
            this.dataset.content = '';
        },
    
        optionSelect(newVal) {
            this.optionSelected = this.getOptionDetailsByClass(this.selectedClassType, newVal);
        },
    },
  
    computed: {
        hasCreditor() {
            return (
            this.dataset &&
            this.dataset.userData &&
            this.dataset.userData.adjusted_creditor &&
            Array.isArray(this.dataset.userData.adjusted_creditor) &&
            this.dataset.userData.adjusted_creditor.length > 0
            );
        },

        getOptionLongText() {
            if (
                this.optionDetailsByClass &&
                this.optionDetailsByClass[this.selectedClassType] &&
                this.optionDetailsByClass[this.selectedClassType][this.optionSelect]
            ) {
                return (
                    this.optionDetailsByClass[this.selectedClassType][this.optionSelect].col8 ||
                    "Nenhum detalhe disponível para esta opção."
                );
            }
            return "Nenhum detalhe disponível.";
        },

        allCheckmarksChecked() {
            return (
            this.dataset.confirmReadPlan &&
            this.dataset.acceptTerms &&
            this.dataset.acceptResponsibility &&
            this.dataset.acceptRemoveAdhesionAgc
            );
        },
    
        isUserDataIncomplete() {
            return (
            this.dataset &&
            this.dataset.userData &&
            (!this.dataset.userData.address_street || !this.dataset.userData.address_city)
            );
           
        },

        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },

        planPdfUrl() {
            return `${window.location.origin}/termo-adesao.pdf`;
        },

        planViewerUrl() {
            if (!this.isMobile) {
                return '/termo-adesao.pdf#toolbar=0&navpanes=0&scrollbar=0';
            }

            const encodedUrl = encodeURIComponent(this.planPdfUrl);
            return `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
        },
  
         processedContent() {
            if (!this.showProcessedContent) return '';

            let content = this.dataset.content || '';

            const today = new Date();
            const localDateFormatted = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
            const updatedAt = this.dataset.adherence && this.dataset.adherence.updated_at;
            const formattedUpdatedAt = updatedAt ? new Date(updatedAt).toLocaleDateString('pt-BR') : localDateFormatted;
            const finalLocalDate = this.termLocalTimeUpdate == null ? formattedUpdatedAt : new Date(this.termLocalTimeUpdate).toLocaleDateString('pt-BR');

            let approvedReps = [];

            if (Array.isArray(this.representatives)) {
                approvedReps = this.representatives.filter(rep => rep.status === 1);
            }

            const userData = this.dataset.userData || {};
            const lawyer = userData.lawyer || {};
            const isCompany = this.isCNPJ(userData.registration);

            const lawyerIsExecutor = Number(lawyer.is_executor) === 1;

            let signatureBlock = "";

            if (isCompany && approvedReps.length > 0) {
                const repsText = approvedReps
                    .map(rep => `${rep.name.toUpperCase()}, ${this.getFormattedRegistration(rep.registration)}`)
                    .join(" e ");

                signatureBlock += `, representado por ${repsText}`;
            }

            if (lawyer && lawyer.name) {
                const connector = isCompany && approvedReps.length > 0 ? " e " : " ";
                const lawyerName = lawyer.name.toUpperCase();


                if (lawyerIsExecutor) {
                    signatureBlock +=
                        `${connector}, por intermédio de seu INVENTARIANTE ${lawyerName}`
                        + `${lawyer.email ? `, email: ${lawyer.email}` : ''}`
                        + `${lawyer.registration ? `, ${this.getFormattedRegistration(lawyer.registration)}` : ''}`;
                        
                } 
                else {
                    const lawPhrase = isCompany
                        ? "por intermédio de seu procurador"
                        : "representado por seu procurador";

                    signatureBlock +=
                        `${connector}${lawPhrase} ${lawyerName}`
                        + `${lawyer.federal_registration ? `, OAB ${lawyer.federal_registration}` : ''}`
                        + `${lawyer.federal_registration_uf ? ` - com seccional - ${lawyer.federal_registration_uf}` : ''}`;
                }
            }

            let creditorClassName = 'CLASSE';
            let amount = 0;

            if (this.hasMoreClass && this.hasMoreClass.length >= 2 && this.selectedClass) {
                const selected = this.hasMoreClass.find(c => c.id === this.selectedClass);
                if (selected) {
                    creditorClassName = selected.name;
                    amount = selected.raw && selected.raw.amount ? selected.raw.amount : 0;
                }
            } else {
                const adjustedCreditor = userData.adjusted_creditor;
                if (adjustedCreditor && adjustedCreditor.length > 0) {
                    const foundClass = this.creditorTypes.find(c => c.id === adjustedCreditor[0].type);
                    if (foundClass) {
                        creditorClassName = foundClass.name;
                        amount = adjustedCreditor[0].amount || 0;
                    }
                }
            }

            const {clause_1, clause_2} = this.getClausesText(this.selectedClassType, this.optionSelect);

            const amountFormatted = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(amount);

            const creditorNameValue = (userData.name || '').toUpperCase();
            const creditorDisplayName = lawyerIsExecutor ? `ESPÓLIO DE ${creditorNameValue}` : (creditorNameValue || 'NOME DO CREDOR');

            const replacements = {
                '{creditor_name}': creditorDisplayName,
                '{creditor_registration}': this.getFormattedRegistration(userData.registration),
                '{creditor_nationality}':userData.nationality || 'nacionalidade',
                '{creditor_email}': lawyerIsExecutor ? '' : (userData.email || 'email'),
                '{creditor_class}': creditorClassName,
                '{address_city}': userData.address_city || 'CIDADE',
                '{local_date}': finalLocalDate,
                '{address_street}': userData.address_street || 'Rua',
                '{address_number}': userData.address_number ? userData.address_number + (userData.address_complement ? ' /' : ',') : 'Nº',
                '{address_complement}': userData.address_complement ? `${userData.address_complement},` : '',
                '{address_neighborhood}': userData.address_neighborhood || 'Bairro',
                '{address_state}': userData.address_state || 'Estado',
                '{address_postal_code}': userData.address_postal_code || 'CEP',
                '{creditor_amount}': amountFormatted,
                '{amount_in_words}': this.numberInWords(amount),
                '{selected_option}': this.selectedClassType === 1 ? 'opção de pagamento prevista' : this.selectedTextOption,
                '{representative_name}': signatureBlock,
                '{representative_registration}': "",
                '{clause_1}': clause_1,
                '{clause_2}': clause_2,
            };

            for (const [token, value] of Object.entries(replacements)) {
                const regex = new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                content = content.replace(regex, String(value));
            }

            if (this.selectedClassType && this.optionSelect) {
                const optionDescription = this.optionSelected && this.optionSelected.col8
                    ? `<div style="margin-top: 24px;">${this.optionSelected.col8}</div>`
                    : '';

                if (content.includes('{description_option}')) {
                    content = content.replace('{description_option}', optionDescription);
                } else if (optionDescription) {
                    content += optionDescription;
                }
            } else {
                content = content.replace('{description_option}', '');
            }

            return content;
        },

        selectedTextOption() {
            const optionsForClass = this.enumTermOptionsByClass[this.selectedClassType] || [];
            const selectedOption = optionsForClass.find(opt => opt.value === this.optionSelect);
            return selectedOption ? selectedOption.text : 'Opção';
        },
    },

    created() {
      if (this.$root.user) {
        this.user = this.$root.user;
        this.loadCreditors();
        this.loadDescription();
      }
    },
  
    methods: {
        openRegister() {
            eventHub.$emit('DIALOG-REGISTER', true);
        },
  
        async refreshCreditorList() {
            this.selectedClass = null;
            this.selectedClassType = null;
            this.showProcessedContent = false;
            this.optionSelect = null;
            this.optionSelected = null;
        },

        async confirmReadPlan() {
            if (!this.dataset.confirmedRead) return;
        },
  
        getOptionsByClass(classType) {
            return this.enumTermOptionsByClass[classType] || [];
        },
  
        getOptionDetailsByClass(classType, optionValue) {
            const options = this.optionDetailsByClass[classType];
            return options && optionValue ? options[optionValue] : null;
        },
  
        getClassTitle(classType) {
            const type = this.creditorTypes.find(t => t.id === classType);
            return type ? type.name : 'Classe Desconhecida';
        },
  
        // mapKeyToLabel(key) {
        //     const labels = {
        //         col1: 'Limite de Pagamento',
        //         col2: 'Deságio',
        //         col3: 'Carência',
        //         col4: 'Forma de pagamento',
        //         col5: 'Parcelas',
        //         col6: 'Atualização',
        //         col7: 'Cashback',
        //     };
        //     return labels[key] || key;
        // },

        getClausesText(classType, optionSelect) {
            let clause_1 = '';
            let clause_2 = '';

            switch (classType) {
                case 3:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.3';
                            break;
                        case 2:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.4';
                            break;
                        case 3:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.5';
                            break;
                        case 4:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.6';
                            break;
                        case 5:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.7';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;

                case 1:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ' ';
                            clause_2 = ' na Cláusula 7';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;

                case 4:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ', nos termos da Cláusula 10.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 10.2';
                            break;
                        case 2:
                            clause_1 = ', nos termos da Cláusula 10.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 10.3';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;
                    
                default:
                    clause_1 = '';
                    clause_2 = '';
                    break;
            }

            return { clause_1, clause_2 };
        },

        onClassChanged() {
            this.showButtonConfirm = true;
            this.dataset.selectedClass = null;
            this.showProcessedContent = false;
        },

        isCNPJ(value) {
            const onlyDigits = (value || '').replace(/\D/g, '');
            return onlyDigits.length === 14;
        },

        getFormattedRegistration(value) {

            if (!value) return 'CPF/CNPJ';

            const cleanValue = value.replace(/\D/g, '');

            return this.isCNPJ(cleanValue) ? `CNPJ: ${cnpj.format(cleanValue)}` : `CPF: ${cpf.format(cleanValue)}`;
        },

        async confirmOption() {
            if (!this.optionSelect) {
                this.$dialog.message.error('Nenhuma opção selecionada. Por favor, selecione uma opção antes de confirmar.');
                return;
            }
            this.showClassOptionModal = false;
            this.showProcessedContent = false;
            this.termLocalTimeUpdate = new Date();
            await this.loadContent();
            await this.loadPlanAdherenceStatus();
            this.showProcessedContent = true;
            
            await this.trackActionEvent({
                eventType: EVENT_TYPE.OPTION_SELECTED,
                step: EVENT_STEP.OPTION_SELECTION,
                value: this.optionSelect,
                metadata: {
                    class_type: this.selectedClassType,
                    option_selected: this.optionSelect,
                    creditor_id: this.selectedCreditor.id,
                }
            })
        },

        async onCreditorChange() {
            
            this.loadingContinue = true;

            const creditor = this.selectedCreditor;
            
            await this.trackActionEvent({
                eventType: EVENT_TYPE.CHECKBOX_ALL_CONFIRMED ,
                step: EVENT_STEP.ALL_CONFIRMED,
                value: null,
                metadata: {
                    confirmReadPlan: this.dataset.confirmReadPlan,
                    acceptTerms: this.dataset.acceptTerms,
                    acceptResponsibility: this.dataset.acceptResponsibility,
                    acceptRemoveAdhesionAgc: this.dataset.acceptRemoveAdhesionAgc,
                    creditor_id: creditor.id,
                    allowedSignature: this.dataset.allowedSignature,
                    hasCreditor: this.hasCreditor
                }
            })

            await this.loadUserData(creditor);

            const creditors = this.dataset && this.dataset.userData && this.dataset.userData.adjusted_creditor ? this.dataset.userData.adjusted_creditor : [];
            
            await this.loadObjection(creditor);

            const relevantClass = creditors.find(c => [1, 3, 4].includes(Number(c.type)));

            if (!relevantClass) {
                await this.loadContent();
                await this.loadPlanAdherenceStatus();
                this.dataset.confirmedRead = true;
                this.showProcessedContent = true;
                this.loadingInitial = false;
                return;
            }

            this.selectedClassType = relevantClass.type;

            if (!this.hasMoreClass) {
                this.dataset.confirmedRead = true;
                this.loadingInitial = false;

                if (this.isUserDataIncomplete) return;
                
                if (!this.dataset.allowedSignature) return;

                await this.handleAdherenceStatus();
            }
            this.loadingContinue = false;
            this.dataset.confirmedRead = true;
            this.loadingInitial = false;
        },

        async onCreditorChangeFirtLoad(creditor) {
            
            if (!creditor) return;

            this.trackActionEvent({
                eventType: EVENT_TYPE.CREDITOR_SELECTED,
                step: EVENT_STEP.CREDITOR_SELECTION,
                value: creditor.id,
                metadata: {
                    creditor_id: creditor.id,
                }
            });

            this.dataset.adherence = {};
            this.selectedClass = null;
            this.selectedClassType = null;
            this.hasMoreClass = null;
            this.showProcessedContent = false;
            this.optionSelect = null;
            this.optionSelected = null;
            this.loadingInitial = true;
            this.dataset.confirmedRead = false;
            this.loadingContinue = false;

            this.dataset.confirmReadPlan = false,
            this.dataset.acceptTerms = false,
            this.dataset.acceptResponsibility = false,
            this.dataset.acceptRemoveAdhesionAgc = false,

            this.dataset.loading = true;

            const response = await axios.get(`/api/lawyer/plan-adherence-status-information`, {
                params: { creditor_id: creditor.id }
            });

            const result = response.data.content.data
            const data = Array.isArray(result) ? result : [];

            const allConfirmed = data.length > 0 && data.every(item => Number(item.status) === 1);

            if (allConfirmed) {
                await this.onCreditorChange(creditor);
                this.dataset.confirmedRead = true;
            }else{
                this.loadingInitial = false;
            } 

            this.dataset.loading = false;
        },

        async loadObjection(creditor) {

            const response = await axios.get(`/api/user-objection-events/lawyer/request-information/${creditor.id}`)

            var result = response.data.content

            if (!result || !result.length) {
                this.dataset.allowedSignature = true;
                return
            }

            const reqData = result[0];

            if (reqData.status == 1 || reqData.status == 2 || reqData.status == 3) {
                this.dataset.allowedSignature = true;
                return
            }
        },

        async confirmSelectedClass() {
            if (!this.selectedClass) {
                this.$dialog.message.error('Nenhuma classe selecionada. Por favor, selecione uma classe antes de confirmar.');
                return;
            }

            const selected = this.creditorTypes.find(item => item.id === this.selectedClass);

            if (!selected) {
                return;
            }

            this.selectedClassType = selected.id;
            this.dataset.selectedClass = selected.id;

            this.showButtonConfirm = false;

            await this.handleAdherenceStatus();
        },

        async handleAdherenceStatus() {

            await this.loadPlanAdherenceStatus();

            const { plan_option: planOption, status: status } = this.dataset.adherence || {};

            if (status === 1) {
                this.optionSelect = planOption;
                this.showProcessedContent = false; 
                await this.loadContent();
                this.showProcessedContent = true;
                return;
            }

            if (planOption != null) {
                this.showProcessedContent = false;
                const confirmReplace = await this.$dialog.confirm({
                    text: 'Já foi gerado um arquivo pdf com o termo de adesão. Deseja gerar um novo arquivo e substituir o anterior?',
                    title: 'Termo de Adesão existente!',
                    html: true,
                    actions: { false: 'NÃO', true: 'SIM' },
                });

                if (confirmReplace) {
                    this.optionSelect = null;
                    this.optionSelected = null;
                    this.showClassOptionModal = true;
                } else {
                    
                    this.optionSelect = planOption;
                    this.optionSelected = this.getOptionDetailsByClass(this.selectedClassType, planOption);
                    this.showProcessedContent = false;
                   
                    await this.loadContent();
                    this.showProcessedContent = true;
                   
                }
            } else {
                this.optionSelect = null;
                this.optionSelected = null;
                this.showClassOptionModal = true;
            }
        },

        async loadDescription() {

            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'plan-adherence-description' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.description = result.data.content[0].value;
                } else {
                    this.dataset.description = '';
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadContent() {

            if(this.isUserDataIncomplete){
                return
            }

            this.dataset.loadingData = true;

            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'plan-adherence-content' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.content = result.data.content[0].value;
                } else {
                    this.dataset.content = '';
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }finally {
                this.dataset.loadingData = false;
            }
        },

        async loadCreditors() {
            this.dataset.loadingCreditors = true;
            try {
                const response = await axios.get(`/api/lawyers/associated-approved-users`);

                if (response.data && response.data.content && Array.isArray(response.data.content.data)) {
                    this.creditors = response.data.content.data.map(item => ({
                        id: item.user.id,
                        name: item.user.name,
                        registration: item.user.registration,

            

                    }));
                } else {
                    this.creditors = [];
                }

            } catch (error) {
                this.$dialog.notify.error('Erro ao carregar lista de credores. ' + this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000,
                });
                this.creditors = [];
            } finally {
                this.dataset.loadingCreditors = false;
            }
        },

        async loadUserData(creditor) {

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/lawyer/plan-adherence-user-data`, {
                    params: {
                        creditor_id: creditor.id
                    }
                });

                const data = result.data.content.data;

                if (data && Object.keys(data).length > 0) {
                    this.dataset.userData = data;
                } else {
                    this.dataset.userData = {};
                }

                if (data && Array.isArray(data.adjusted_creditor) && data.adjusted_creditor.length > 1) {

                    this.hasMoreClass = data.adjusted_creditor.map(item => {
                        const foundClass = this.creditorTypes.find(c => c.id === item.type);
                        return {
                            id: item.type,
                            name: foundClass ? foundClass.name : `Classe ${item.type}`,
                            raw: item
                        };
                    });
                }

                if (data && Array.isArray(data.representatives)) {
                    this.representatives = data.representatives.map(item => ({
                        id: item.id,
                        name: item.name,
                        registration: item.registration,
                        status: item.status
                    }));
                } else {
                    this.representatives = [];
                }

                console.log("REP: ",this.representatives)
                
                // if (data.adjusted_creditor.length === 1 || this.selectedClassType){
                //     this.loadContent();
                // }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async confirmAndProceed() {

            this.showSignatureInfo = false
            
            await this.generatePdf();
        },

        async generatePdf() {
            if (this.$moduleBlocked('site.plan_adherence')) return;
            this.dataset.downloading = true

            try {
                const response = await axios.post('/api/lawyer/generate-creditor-pdf', {
                    plan_details: this.getPlanDetailsForPdf(),
                    creditor_id: this.selectedCreditor.id,
                    class_type: this.selectedClassType,
                    plan_option: this.optionSelect,
                    confirmed_read_plan: this.dataset.confirmReadPlan,
                    accept_responsibility: this.dataset.acceptResponsibility,
                    accept_terms: this.dataset.acceptTerms,
                    accept_remove_adhesion: this.dataset.acceptRemoveAdhesionAgc
                }, {
                    responseType: 'blob'
                })

                const name = this.selectedCreditor.name || 'documento'
                const filename = `termo_adesao_${name}.pdf`

                await downloadPdfResponse(response, filename, 'Termo de adesão ao plano')

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_GENERATED,
                    step: EVENT_STEP.PDF_GENERATION,
                    value: null,
                    metadata: {
                        class_type: this.selectedClassType,
                        plan_option: this.optionSelect,
                        file_name: filename,
                        creditor_id: this.selectedCreditor.id,
                    }
                })

                await this.$dialog.confirm({
                    text: `O arquivo PDF foi gerado com sucesso!<br>
                    Nome do arquivo: <strong>${filename}</strong>.<br><br>
                    Por padrão, o arquivo é salvo na pasta <strong>Downloads</strong> ou na pasta configurada como padrão no seu navegador.<br><br>
                    O arquivo PDF gerado pode ser assinado por <strong>${this.selectedCreditor.name || ''}</strong> ou pelo seu procurador devidamente credenciado.<br><br>
                    Após a assinatura, retorne a esta página e faça o upload do arquivo PDF assinado.<br><br>
                    <strong>Obs.:</strong> A assinatura digital deve ser feita através da plataforma <strong>gov.br</strong>, utilizando conta de nível <strong>prata</strong> ou <strong>ouro</strong>.<br><br>
                    `,
                    title: 'PDF Gerado',
                    actions: {
                        true: 'OK'
                    },
                    html: true
                })

            } catch (error) {
                let errorMessage = 'Erro ao gerar/baixar arquivo PDF! Tente novamente.'

                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text()
                        const json = JSON.parse(text)
                        errorMessage = json.content.error.message || errorMessage
                    } catch (parseError) {
                        console.error('Erro ao parsear arquivo', parseError)
                    }
                }

                this.$dialog.notify.error(errorMessage, {
                    position: 'top-right',
                    timeout: 5000,
                })
            } finally {
                this.loadPlanAdherenceStatus()
                this.dataset.downloading = false
            }
        },

        async uploadPdf(file) {
            if (this.$moduleBlocked('site.plan_adherence')) return;
            
            if (!file) return
            
            if (!this.selectedCreditor) {
                this.$dialog.notify.warn('Nenhum credor selecionado para fazer o upload do PDF.', { timeout: 3000 });
                return;
            }

            this.trackingUploadContext = true;
            
            this.dataset.uploading = true
            
            try {
                const formData = new FormData()

                formData.append('signed_pdf', file)
                formData.append('creditor_id', this.selectedCreditor.id);

                if (this.selectedClassType !== undefined && this.selectedClassType !== null) {
                    formData.append('class_type', this.selectedClassType );
                }

                const response = await axios.post('/api/lawyer/upload-signed-pdf', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })

                this.$dialog.notify.info(`Arquivo PDF enviado com sucesso!`, {
                    position: "top-right",
                    timeout: 5000,
                });

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    value: null,
                    metadata: {
                        class_type: this.selectedClassType,
                        option: this.optionSelect,
                        creditor_id: this.selectedCreditor.id,
                        file: file.name,
                    }
                })

                this.signedPdf = null

            } catch (error) {

                const httpStatus = error && error.response && error.response.status ? error.response.status : null;

                const errorCode = (error && error.code) || (error && error.response && error.response.data && error.response.data.code) || null;

                let errorMessage = 'Ocorreu um erro ao enviar o PDF. Tente novamente.'; 

                if (error.response && error.response.data && error.response.data.content && error.response.data.content.error) {
                    errorMessage = error.response.data.content.error.message;
                } else if (this.$codes(error)) { 
                    errorMessage = this.$codes(error);
                }

                await this.$dialog.confirm({
                    text: errorMessage,
                    title: 'Erro no envio do documento PDF',
                    actions: {
                        true: 'OK'
                    },
                    html: true 
                });

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOAD_ERROR,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        class_type: this.selectedClassType,
                        option: this.optionSelect,
                        creditor_id: this.adherenceUserId,
                        file: file.name || null,
                        error_message: errorMessage,
                        error_code: errorCode,
                        http_status: httpStatus
                    }
                })

                console.error('Erro ao enviar PDF:', error)

            } finally {
                //this.loadPlanAdherenceStatus();
                const adherence = await this.loadPlanAdherenceStatus();

                if (this.trackingUploadContext && adherence.status != null) {
                    await this.trackUploadResult(adherence.status)
                }

                this.trackingUploadContext = false
                this.dataset.uploading = false
            }
        },

        numberInWords(valor) {
            const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
            const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
            const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
            const centenas = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];
            const qualificadores = [
                ["", ""],
                ["mil", "mil"],
                ["milhão", "milhões"],
                ["bilhão", "bilhões"],
                ["trilhão", "trilhões"]
            ];

            function numberToLong(n) {
                let resultado = "";

                if (n === 0) return "";

                if (n > 999) {
                    throw new Error("Número fora de faixa para esta função interna.");
                }

                if (n === 100) return "cem";

                const c = Math.floor(n / 100);
                const d = Math.floor((n % 100) / 10);
                const u = n % 10;

                if (c !== 0) resultado += centenas[c];

                if (d === 1) {
                    resultado += (resultado ? " e " : "") + especiais[u];
                } else if (d > 1) {
                    resultado += (resultado ? " e " : "") + dezenas[d];
                    if (u !== 0) resultado += " e " + unidades[u];
                } else if (u !== 0) {
                    resultado += (resultado ? " e " : "") + unidades[u];
                }

                return resultado;
            }

            function generateLong(valor) {
                if (valor === 0) return "zero";

                const partes = [];
                let inteiro = Math.floor(valor);
                let centavos = Math.round((valor - inteiro) * 100);

                const segmentos = [];
                let pos = 0;

                while (inteiro > 0) {
                    segmentos.push(inteiro % 1000);
                    inteiro = Math.floor(inteiro / 1000);
                    pos++;
                }

                for (let i = segmentos.length - 1; i >= 0; i--) {
                    const numero = segmentos[i];
                    if (numero === 0) continue;

                    const texto = numberToLong(numero);
                    const qualificador = qualificadores[i];

                    if (i > 0 && numero === 1) {
                        partes.push(texto + " " + qualificador[0]);
                    } else if (i > 0) {
                        partes.push(texto + " " + qualificador[1]);
                    } else {
                        partes.push(texto);
                    }
                }

                let resultado = partes.join(", ").replace(/, ([^,]*)$/, " e $1");

                if (resultado.endsWith(", ")) {
                    resultado = resultado.slice(0, -2);
                }

                if (resultado.includes(", e")) {
                    resultado = resultado.replace(", e", " e");
                }

                resultado += (Math.floor(valor) === 1 ? " real" : " reais");

                if (centavos > 0) {
                    resultado += " e " + numberToLong(centavos) + (centavos === 1 ? " centavo" : " centavos");
                }

                return resultado;
            }

            return generateLong(parseFloat(valor.toFixed(2)));
        },

        getColorByStatus(status) {

            switch (status) {
            case 0:
                return 'warning'
            case 1:
                return 'green'
            case 2:
                return 'important'
            default:
                break
            }
        },

        getTextByStatus(status) {
            switch (status) {
            case 0:
                return 'Aguardando assinatura'
            case 1:
                return 'Assinado'
            case 2:
                return 'Rejeitado'
            default:
                break
            }
        },

        async loadPlanAdherenceStatus() {

            this.dataset.loading = true;

            try {

                const response = await axios.get('/api/lawyer/plan-adherence-status/', {
                    params: {
                        class_type: this.selectedClassType,
                        creditor_id: this.selectedCreditor.id
                    }
                });
                
                const adherenceData = response &&
                    response.data &&
                    response.data.content &&
                    response.data.content.data;

                    this.dataset.adherence = (adherenceData && Object.keys(adherenceData).length > 0)
                        ? adherenceData
                        : {};

                return this.dataset.adherence;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

        async savePdfFromIframe() {

            await this.trackActionEvent({
                eventType: EVENT_TYPE.PDF_DOWNLOADED,
                step: EVENT_STEP.TERMS_REVIEW,
                value: 1, // indica que o pdf foi baixado
                metadata: {
                    file: 'termo-adesao.pdf',
                    origin: 'iframe',
                    screen: 'lawyer-plan-adherence'
                } 
            });
    
            await downloadPdfUrl('/termo-adesao.pdf', 'termo-adesao.pdf', 'Termo de adesão ao plano');
        },

        openPlanPdf() {
            window.open(this.planPdfUrl, '_blank', 'noopener');
        },

        getPlanDetailsForPdf() {
            return this.processedContent || this.dataset.content || '';
        },

        getActionEventUserId(metadata = null) {
            return (this.selectedCreditor && this.selectedCreditor.id)
                || (metadata && metadata.creditor_id)
                || null;
        },

        getActionEventLawyerId() {
            return this.user && this.user.id ? this.user.id : null;
        },

        async trackActionEvent({
            eventType,
            step = null,
            value = null,
            metadata = null,
            }) {
            try {
                const userId = this.getActionEventUserId(metadata);
                const lawyerId = this.getActionEventLawyerId();

                if (!userId) {
                    console.warn('Evento de adesão do procurador não enviado: user_id ausente.', {
                        eventType,
                        step,
                        value,
                        metadata,
                    });
                    return;
                }

                const payload = {
                    process_type: this.process_type.LAWYER_PLAN_ADHERENCE,
                    event_type: eventType,
                    step,
                    value,
                    metadata,
                    user_id: userId,
                    lawyer_id: lawyerId,
                }

                await axios.post('/api/action-events', payload)

            } catch (error) {
                console.warn('Erro ao registrar evento:', error)
            }
        },

        async trackUploadResult(status) {

            const creditorId = this.selectedCreditor.id

            if (status === 1) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PROCESS_FINISHED,
                    step: EVENT_STEP.FINISHED,
                    metadata: { 
                        creditor_id: creditorId,
                        result: 'APPROVED'
                    }
                })
            }

            if (status === 0) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        creditor_id: creditorId,
                        result: 'PENDING'
                    }
                })
            }

            if (status === 2) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        creditor_id: creditorId,
                        result: 'REJECTED'
                    }
                })
            }
        },

        handleInterestChange() {
            this.interestDialog.show = true;
            
            this.interestDialog.selectedClass = this.dataset.adherence ? this.dataset.adherence.type : null;
            this.onInterestClassChanged(this.interestDialog.selectedClass);
            
        },

        onInterestClassChanged(classId) {
            
            this.interestDialog.selectedOption = null;
            
            const optionsForClass = this.enumTermOptionsByClass[classId] || [];
            
            this.interestDialog.availableOptions = optionsForClass;
            
        },

        async submitInterestChange() {
            if (this.$moduleBlocked('site.plan_adherence')) return;
            
            this.interestDialog.loading = true;
            
            const payload = {
                id: this.dataset.adherence ? this.dataset.adherence.id : null,
                user_id: this.dataset.adherence.user_id,
                interest_plan_option: this.interestDialog.selectedOption
            };

            try {
               
                await axios.post('/api/lawyer/update-interest-plan-option', payload);
                
                this.$dialog.notify.success('Interesse em alterar opção manifestado com sucesso!');
                this.interestDialog.show = false;
            } catch (error) {
                this.$dialog.notify.error('Erro ao enviar solicitação.');
            } finally {
                this.interestDialog.loading = false;
            }
        },

        currentOptionText() {
    
            const currentOptionId = this.dataset.adherence ? this.dataset.adherence.plan_option : null;

            if (!currentOptionId) return 'Não selecionada';

            const allOptions = this.enumTermOptionsByClass[3] || [];
            const found = allOptions.find(opt => opt.value === currentOptionId);
            
            return found ? found.text : 'Opção ' + currentOptionId;
        },


    }
};

</script>


<style lang="scss">
    .title-page {
      color: var(--v-primary-base);
      font-family: "Raleway";
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 38px;
    }

    .min-height-0 {
        min-height: 0 !important;
    }

    .plan-pdf-viewer {
        border: 1px solid #d8deea;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
    }

    .plan-pdf-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 12px 16px;
        border-bottom: 1px solid #d8deea;
        background: #f8fafc;
    }

    .plan-pdf-actions {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .plan-pdf-frame {
        display: block;
        width: 100%;
        height: 70vh;
        min-height: 560px;
    }

    @media (max-width: 600px) {
        .plan-pdf-toolbar {
            align-items: flex-start;
            flex-direction: column;
            padding: 12px;
        }

        .plan-pdf-actions {
            width: 100%;
            gap: 8px;
            justify-content: flex-start;
        }

        .plan-pdf-actions .v-btn {
            margin-right: 0 !important;
        }

        .plan-pdf-frame {
            height: 72vh;
            min-height: 520px;
        }
    }
</style>
